import sectionBannerMediaCss from '../css-snippets/section-banner-media';

const html = ` 
<style>${sectionBannerMediaCss}</style>
<div
  class="banner-media-wrapper banner-media-wrapper-unique-id"
  data-attribute="banner-media-wrapper"
  data-id="unique-id"
  data-top-padding="true"
  data-bottom-padding="true"
  data-image-background-desktop="https://cdn.skyfastimg.com/images/2026/03/17/image-69b90dfa068e083f060fb3b5.webp?w=1200&h=50&q=80"
  data-image-background-mobile="https://cdn.skyfastimg.com/images/2026/03/17/image-69b90e20546c4d385ed7c153.png?w=500&h=50&q=80"
  style="
    --image-background-desktop: url(&quot;https://cdn.skyfastimg.com/images/2026/03/17/image-69b90dfa068e083f060fb3b5.webp?w=1200&h=50&q=80&quot;);
    --image-background-mobile: url(&quot;https://cdn.skyfastimg.com/images/2026/03/17/image-69b90e20546c4d385ed7c153.png?w=500&h=50&q=80&quot;);
  "
>
  <div data-attribute="banner-media-container" class="banner-media-container">
    <div class="banner-media-inner">
      <div data-attribute="banner-media-title" class="banner-media-title">
        <h2 style="text-align: center">
          <span><strong>SEE HOW IT WORKS</strong></span>
        </h2>
      </div>
      <div
        class="banner-media-play-icon"
        data-attribute="banner-media-play-icon"
        data-video-url="https://www.youtube.com/watch?v=kiI-CRkHGXo&autoplay=1"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
          <path
            d="M187.2 100.9C174.8 94.1 159.8 94.4 147.6 101.6C135.4 108.8 128 121.9 128 136L128 504C128 518.1 135.5 531.2 147.6 538.4C159.7 545.6 174.8 545.9 187.2 539.1L523.2 355.1C536 348.1 544 334.6 544 320C544 305.4 536 291.9 523.2 284.9L187.2 100.9z"
          />
        </svg>
      </div>
    </div>
    <div class="banner-media-overlay" data-attribute="banner-media-overlay"></div>
  </div>
</div>
<div class="banner-media-modal">
  <div class="banner-media-modal-inner">
    <button
      type="button"
      class="banner-media-modal-close"
      data-banner-media-close
      aria-label="Close video modal"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M18 6 6 18"></path>
        <path d="m6 6 12 12"></path>
      </svg>
    </button>
    <div class="banner-media-modal-body"></div>
  </div>
</div>
`;

export default html;
